/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownRole } from '../models/db_DropdownRole';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Roles {
    /**
     * Get a list of roles
     * @returns db_DropdownRole OK
     * @throws ApiError
     */
    public static listRoles(): CancelablePromise<Array<db_DropdownRole>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/roles',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
